<template>
  <div>
    <div v-for="(parent, idx) in local_value" :key="idx" :class="[!parent.children ? 'has-border-bottom' : '', parent.children && !parent.expand ? 'has-border-bottom' : '']">
      <div :style="{ 'padding-left': i * 20 + 'px' }" class="is-flex is-align-items-center">
        <a @click.prevent="handleOptionToggle(parent)" v-if="!parent.children || field?.select_root || main_local_value?.is_standalone_multiple == 1" class="mr-1">
          <i class="fa" :class="[selected_options[parent.id] ? 'fa-square-check' : 'fa-square has-text-grey-light']"></i>
        </a>
        <div v-else style="width: 17px; height: 13px; display: inline-block">&nbsp;</div>
        <a class="item-tree is-flex is-align-items-center is-flex-grow-1" href="" @click.prevent="collapse(parent)">
          <span class="tree-select-row-text" :class="{ 'has-text-success-dark': Object.keys(selected_options).includes(parent.id) }">
            {{ parent.label }}
          </span>
          <i
            class="fa tree-select-caret"
            :class="{
              'fa-caret-down': !parent.expand,
              'fa-caret-up': parent.expand,
            }"
            v-if="parent.children"
          ></i>
        </a>
        <label class="ml-auto mr-5 checkbox" v-if="parent.children && parent.children.length > 0 && main_local_value?.is_multiple == 1">
          <input type="checkbox" :checked="areAllChildrenSelected(parent)" @change="toggleChildren(parent)" />
        </label>
      </div>
      <div class="children-tree">
        <div v-if="parent.expand && parent.children" class="has-border-top">
          <tree-options
            :root_value="root_value"
            :i="i + 1"
            :selected_options="selected_options"
            :inherited_selected_options="inherited_selected_options"
            :options="parent.children"
            :field="field"
            :main_local_value="main_local_value"
            @toggle-children="$emit('toggle-children', $event)"
            @toggle-option="$emit('toggle-option', $event)"
          ></tree-options>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import treeOptions from "./tree-option";
import { inject } from "vue";

export default {
  name: "tree-options",
  components: {
    treeOptions,
  },
  setup() {
    return {
      selectedvalue: inject("selectedvalue"),
    };
  },
  data() {
    return {
      local_value: [],
      selected: false,
    };
  },
  watch: {
    options: {
      handler: function (val) {
        this.checkforinheritance(val);
      },
      deep: true,
    },
  },
  props: [
    "options",
    "i",
    "root_value",
    "selected_options",
    "inherited_selected_options",
    "field",
    "main_local_value", // Add this new prop
  ],
  methods: {
    collapse(p) {
      if (!p.children) {
        // If it's a leaf node, or if we are in is_standalone_multiple mode,
        // directly toggle selection via the parent component.
        if (this.main_local_value?.is_standalone_multiple == 1 || !p.children) {
          this.$emit("toggle-option", p);
        } else {
          // Original behavior for standard multiple/single select
          p.value = p.id;
          this.selectedvalue = p;
        }
      }
      this.local_value = [
        ...this.local_value.map((e) => {
          if (e.id == p.id) {
            e.expand = !e.expand;
          }
          return e;
        }),
      ];
    },

    checkforinheritance(options) {
      if (this.inherited_selected_options)
        this.local_value = [
          ...options.filter((o) => {
            var include = true;
            this.inherited_selected_options.map((io) => {
              if (io.accessory_id == o.id) {
                include = false;
              }
            });
            return include;
          }),
        ];
      else this.local_value = [...options];
    },

    // Helper function to recursively get all descendant IDs
    getAllDescendantIds(node, ids = []) {
      if (node.children) {
        node.children.forEach((child) => {
          ids.push(child.id);
          this.getAllDescendantIds(child, ids);
        });
      }
      return ids;
    },

    // Method to check if all children (and their descendants) of a parent are selected
    areAllChildrenSelected(parent) {
      if (!parent.children || parent.children.length === 0) {
        return false;
      }
      // Collect all descendant IDs including the parent itself
      const descendantIds = [parent.id];
      this.getAllDescendantIds(parent, descendantIds);
      // Check if all collected descendant IDs are in selected_options
      return descendantIds.every((id) => this.selected_options && this.selected_options[id]);
    },

    // Method to toggle selection of all children for a specific parent
    toggleChildren(parent) {
      this.$emit("toggle-children", parent);
    },

    // New method to handle individual option toggling
    handleOptionToggle(option) {
      this.$emit("toggle-option", option);
    },
  },

  created() {
    this.checkforinheritance(this.options);
  },
};
</script>

<style scoped>
.children-tree {
  display: flex;
  flex-direction: column;
}
.item-tree {
  flex: 1 1 0px;
  width: 100%;
  min-width: 0;
  padding: 8px 4px;
}
.tree-select-row-text {
  flex: 1 1 auto;
  min-width: 0;
  line-height: 1.35;
}
.tree-select-caret {
  flex: 0 0 auto;
  margin-left: 8px;
  color: #64748b;
}
.has-border-bottom {
  border-bottom: 1px solid #dbdbdb;
}
.has-border-top {
  border-top: 1px solid #dbdbdb;
}
</style>
